<template>
  <!-- View Legal basis modal template -->
  <b-modal ref="view-io" hide-footer @hide="hidePolicyModal" v-if="object">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('systems.log_management.view.title') }}
      </h4>
    </div>

    <label class="mt-3">
      {{ $t('systems.log_management.table.name') }}
    </label>
    <br>
    <span v-if="object.log_management" qid="log-management-name">
      {{ object.log_management.name }}
    </span>
    <br>

    <div v-if="object.description">
      <label class="mt-4">
        {{ $t('systems.log_management.table.description') }}
      </label>
      <br>
      <div class="text-formatted mt-minus-1 mb-minus-1"
            qid="log-management-description"
      >
        {{ object.description }}
      </div>
      <br>
    </div>

    <div v-if="object.log_collection">
      <label class="mt-4">
        {{ $t('systems.log_management.table.log_collection') }}
      </label>
      <br>
      <span qid="log-management-log_collection">
        {{ object.log_collection }}
      </span>
      <br>
    </div>

    <div v-if="object.log_analysis">
      <label class="mt-4">
        {{ $t('systems.log_management.table.log_analysis') }}
      </label>
      <br>
      <span qid="log-management-log_analysis">
        {{ object.log_analysis }}
      </span>
      <br>
    </div>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hidePolicyModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.policies.view.close') }}
    </b-button>
    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'LogManagementViewModal',
    data: function() {
      return {
        error: '',
        processGroup: [],
        showInput: false,
        loadingItems: false,
        showArticleDescription: false
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showPolicyModal()
        }
      }
    },
    methods: {
      showPolicyModal() {
        let self = this
        this.$refs['view-io'].show()
      },
      hidePolicyModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-io'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
